import * as Vuex from "vuex";
import { auth } from "./authenticate";
import { State } from "./state";
import {emailRecord} from "@/store/EmailRecord";
import {channelRecord} from "@/store/Channel";
import {topicRecord} from "@/store/Topic";
import {postRecord} from "@/store/Posts";

export const createStore = () => new Vuex.Store<State>({
    modules: {
        auth,
        emailRecord,
        channelRecord,
        topicRecord,
        postRecord
    },
});
